<template>
    <div>
        <div class="doctors-sorting">
            <div>Řadit podle:</div>
            <div v-bind:class="{ active: isSorted }"><a @click="sortingByDate('newest')">Od nejnovějších</a></div>
            <div v-bind:class="{ active: !isSorted }"><a @click="sortingByDate('oldest')">Od nejstarších</a></div>
        </div>
        <div class="doctors-list">
            <h1>lékař / skupina</h1>
            <div class="no-data" v-if="doctors.length === 0">
                <figure>
                    <svg
                        width="108px"
                        height="75px"
                        viewBox="0 0 120 84"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                        <g id="Web-App" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g
                                id="Prázdá-pole---terapeutický/doktor-dashboard"
                                transform="translate(-792.000000, -93.000000)"
                                fill="#B3B1C2"
                            >
                                <path
                                    d="M828,135 C839.60625,135 849,125.60625 849,114 C849,102.39375 839.60625,93 828,93 C816.39375,93 807,102.39375 807,114 C807,125.60625 816.39375,135 828,135 Z M842.4,141 L840.84375,141 C836.94375,142.875 832.6125,144 828,144 C823.3875,144 819.075,142.875 815.15625,141 L813.6,141 C801.675,141 792,150.675 792,162.6 L792,168 C792,172.96875 796.03125,177 801,177 L855,177 C859.96875,177 864,172.96875 864,168 L864,162.6 C864,150.675 854.325,141 842.4,141 Z M882,135 C891.9375,135 900,126.9375 900,117 C900,107.0625 891.9375,99 882,99 C872.0625,99 864,107.0625 864,117 C864,126.9375 872.0625,135 882,135 Z M891,141 L890.2875,141 C887.68125,141.9 884.925,142.5 882,142.5 C879.075,142.5 876.31875,141.9 873.7125,141 L873,141 C869.175,141 865.65,142.10625 862.55625,143.8875 C867.13125,148.81875 870,155.3625 870,162.6 L870,169.8 C870,170.2125 869.90625,170.60625 869.8875,171 L903,171 C907.96875,171 912,166.96875 912,162 C912,150.39375 902.60625,141 891,141 L891,141 Z"
                                    id="Shape"
                                ></path>
                            </g>
                        </g>
                    </svg>
                </figure>
                <p>V této sekci nejsou žádná data</p>
            </div>
            <div v-else class="reporting-doctors" v-for="(doctor, i) of doctors" :key="i">
                <div class="doctors-header">
                    <div class="header-info">
                        <figure class="doctor-avatar" v-html="buildAvatar(doctor)"></figure>
                        <div>
                            {{ doctor.pre_nominal_letters }} {{ doctor.name }} {{ doctor.surname }}
                            {{ doctor.post_nominal_letters }}
                        </div>
                        <div class="reporting-info-icon">
                            <div class="reporting-info-content">
                                <div>
                                    <p>Registrace</p>
                                    <p>{{ dateFormater(doctor.registered_at) }}</p>
                                </div>
                            </div>
                            <a>
                                <svg-icon icon="tooltips.big-info" />
                                <svg-icon icon="tooltips.big-info-hover" />
                            </a>
                        </div>
                        <div>
                            <img :src="region[`${doctor.region}`]" />
                        </div>
                    </div>
                    <div class="header-company">
                        <div>
                            <img :src="doctor.institution.logo" />
                        </div>
                        <div>{{ doctor.institution.name }}</div>
                    </div>
                </div>
                <div class="doctors-body">
                    <div class="reporting-users-funnel">
                        <div class="funnel-body">
                            <div>
                                <div>
                                    <h3>stav uživatelů</h3>
                                </div>
                                <div>
                                    <h3>
                                        status
                                        <br />
                                        celkově
                                    </h3>
                                </div>
                                <div>
                                    <h3>
                                        status za
                                        <br />
                                        období
                                    </h3>
                                </div>
                                <div>
                                    <h3>
                                        události
                                        <br />
                                        za období
                                    </h3>
                                </div>
                            </div>
                            <div>
                                <div class="reporting-list">
                                    <div>
                                        <div>Propojeni s terapeutem</div>
                                        <div>
                                            {{ doctor.patients.connected }}
                                            <div class="reporting-info-icon">
                                                <a>
                                                    <svg-icon icon="tooltips.small-info" />
                                                    <svg-icon icon="tooltips.small-info-hover" />
                                                    <div class="reporting-info-content">
                                                        <div>
                                                            <p>Intenzivní fáze</p>
                                                            <p>
                                                                {{ doctor.connected_by_states['intensive-connected'] }}
                                                            </p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Udržovací fáze</p>
                                                            <p>{{ doctor.connected_by_states.sustain }}</p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Absolventi</p>
                                                            <p>
                                                                {{ doctor.connected_by_states.graduate }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                        <div>
                                            {{
                                                doctor.patients_in_period['intensive-connected'] +
                                                    doctor.patients_in_period.sustain +
                                                    doctor.patients_in_period.graduate
                                            }}
                                            <div class="reporting-info-icon">
                                                <a>
                                                    <svg-icon icon="tooltips.small-info" />
                                                    <svg-icon icon="tooltips.small-info-hover" />
                                                    <div class="reporting-info-content">
                                                        <div>
                                                            <p>Intenzivní fáze</p>
                                                            <p>
                                                                {{ doctor.patients_in_period['intensive-connected'] }}
                                                            </p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Udržovací fáze</p>
                                                            <p>{{ doctor.patients_in_period.sustain }}</p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Absolventi</p>
                                                            <p>
                                                                {{ doctor.patients_in_period.graduate }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                        <div>
                                            {{ doctor.events_in_period['intensive-connected'] }}
                                        </div>
                                    </div>
                                </div>
                                <div class="reporting-list bullet-blue">
                                    <div>
                                        <div>In-app</div>
                                        <div>
                                            {{ doctor.patients.inapp }}
                                        </div>
                                        <div>
                                            {{ doctor.patients_in_period['intensive-inapp'] }}
                                        </div>
                                        <div>
                                            {{ doctor.events_in_period['intensive-inapp'] }}
                                        </div>
                                    </div>
                                </div>
                                <div class="reporting-list bullet-orange">
                                    <div>
                                        <div>Onboarding</div>
                                        <div>
                                            {{ doctor.patients.onboarding }}
                                        </div>
                                        <div>
                                            {{
                                                doctor.patients_in_period.onboarding +
                                                    doctor.patients_in_period['onboarding-pending']
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                doctor.events_in_period.onboarding +
                                                    doctor.events_in_period['onboarding-pending']
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="reporting-list bullet-red">
                                    <div>
                                        <div>Deaktivovaní</div>
                                        <div>
                                            {{ allInactivated(doctor.patients.inactivated) }}
                                            <div class="reporting-info-icon">
                                                <a>
                                                    <svg-icon icon="tooltips.small-info" />
                                                    <svg-icon icon="tooltips.small-info-hover" />
                                                    <div class="reporting-info-content">
                                                        <div>
                                                            <p>Z registrovaných</p>
                                                            <p>{{ doctor.patients.inactivated.onboarding }}</p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Z In-app</p>
                                                            <p>{{ doctor.patients.inactivated.inapp }}</p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Z propojených (intenzivní)</p>
                                                            <p>
                                                                {{
                                                                    doctor.patients.inactivated
                                                                        .inactivated_patients_intensive_phase
                                                                }}
                                                            </p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Z propojených (udržovací)</p>
                                                            <p>
                                                                {{
                                                                    doctor.patients.inactivated.connected -
                                                                        doctor.patients.inactivated
                                                                            .inactivated_patients_intensive_phase
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                        <div>
                                            {{
                                                doctor.inactivated_patients_in_period.onboarding +
                                                    doctor.inactivated_patients_in_period['intensive-inapp'] +
                                                    doctor.inactivated_patients_in_period['intensive-connected'] +
                                                    doctor.inactivated_patients_in_period.sustain
                                            }}
                                            <div class="reporting-info-icon">
                                                <a>
                                                    <svg-icon icon="tooltips.small-info" />
                                                    <svg-icon icon="tooltips.small-info-hover" />
                                                    <div class="reporting-info-content">
                                                        <div>
                                                            <p>Z registrovaných</p>
                                                            <p>
                                                                {{ doctor.inactivated_patients_in_period.onboarding }}
                                                            </p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Z In-app</p>
                                                            <p>
                                                                {{
                                                                    doctor.inactivated_patients_in_period[
                                                                        'intensive-inapp'
                                                                    ]
                                                                }}
                                                            </p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Z propojených (intenzivní)</p>
                                                            <p>
                                                                {{
                                                                    doctor.inactivated_patients_in_period[
                                                                        'intensive-connected'
                                                                    ]
                                                                }}
                                                            </p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Z propojených (udržovací)</p>
                                                            <p>
                                                                {{ doctor.inactivated_patients_in_period.sustain }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                        <div>
                                            {{
                                                doctor.inactivation_events_in_period.onboarding +
                                                    doctor.inactivation_events_in_period['intensive-inapp'] +
                                                    doctor.inactivation_events_in_period['intensive-connected'] +
                                                    doctor.inactivation_events_in_period.sustain
                                            }}
                                            <div class="reporting-info-icon">
                                                <a>
                                                    <svg-icon icon="tooltips.small-info" />
                                                    <svg-icon icon="tooltips.small-info-hover" />
                                                    <div class="reporting-info-content">
                                                        <div>
                                                            <p>Z registrovaných</p>
                                                            <p>
                                                                {{ doctor.inactivation_events_in_period.onboarding }}
                                                            </p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Z In-app</p>
                                                            <p>
                                                                {{
                                                                    doctor.inactivation_events_in_period[
                                                                        'intensive-inapp'
                                                                    ]
                                                                }}
                                                            </p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Z propojených (intenzivní)</p>
                                                            <p>
                                                                {{
                                                                    doctor.inactivation_events_in_period[
                                                                        'intensive-connected'
                                                                    ]
                                                                }}
                                                            </p>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <p>Z propojených (udržovací)</p>
                                                            <p>
                                                                {{ doctor.inactivation_events_in_period.sustain }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="reporting-invited-users">
                        <div class="funnel-body">
                            <div>
                                <div>
                                    <h3>stav pozvánek</h3>
                                </div>
                                <div>
                                    <h3>celkově</h3>
                                </div>
                                <div>
                                    <h3>
                                        události
                                        <br />
                                        za období
                                    </h3>
                                </div>
                            </div>
                            <div>
                                <div class="reporting-list">
                                    <div>
                                        <div>Odeslané pozvánky</div>
                                        <div v-if="doctor.invitated_users.invitations.sent.total">
                                            {{ doctor.invitated_users.invitations.sent.total }}
                                        </div>
                                        <div v-else>0</div>
                                        <div v-if="doctor.invitated_users.invitations.sent.period">
                                            {{ doctor.invitated_users.invitations.sent.period }}
                                        </div>
                                        <div v-else>0</div>
                                    </div>
                                </div>
                                <div class="reporting-list">
                                    <div>
                                        <div>Letáky v oběhu</div>
                                        <div v-if="doctor.invitated_users.flyers.sent.total">
                                            {{ doctor.invitated_users.flyers.sent.total }}
                                        </div>
                                        <div v-else>0</div>
                                        <div v-if="doctor.invitated_users.flyers.sent.period">
                                            {{ doctor.invitated_users.flyers.sent.period }}
                                        </div>
                                        <div v-else>0</div>
                                    </div>
                                </div>
                                <div class="reporting-list">
                                    <div>
                                        <div>Letáky v oběhu (využité)</div>
                                        <div v-if="doctor.invitated_users.flyers.used.total">
                                            {{ doctor.invitated_users.flyers.used.total }}
                                        </div>
                                        <div v-else>0</div>

                                        <div v-if="doctor.invitated_users.flyers.used.period">
                                            {{ doctor.invitated_users.flyers.used.period }}
                                        </div>
                                        <div v-else>0</div>
                                    </div>
                                </div>
                                <div class="reporting-list disable-item">
                                    <div>
                                        <div>Vypršené pozvánky (letáky)</div>
                                        <div>
                                            {{ doctor.invitated_users.expired.invitations.total }} ({{
                                                doctor.invitated_users.expired.flyers.total
                                            }})
                                            <div class="reporting-info-icon">
                                                <a>
                                                    <svg-icon icon="tooltips.small-info" />
                                                    <svg-icon icon="tooltips.small-info-hover" />
                                                    <div class="reporting-info-content invited">
                                                        Pozvánka vypršela po 30 dnech od odeslání pozvánky nebo od
                                                        prvního zadání kódu z letáku.
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                        <div>
                                            {{ doctor.invitated_users.expired.invitations.period }}
                                            ({{ doctor.invitated_users.expired.flyers.period }})
                                            <div class="reporting-info-icon">
                                                <a>
                                                    <svg-icon icon="tooltips.small-info" />
                                                    <svg-icon icon="tooltips.small-info-hover" />
                                                    <div class="reporting-info-content invited">
                                                        Pozvánka vypršela po 30 dnech od odeslání pozvánky nebo od
                                                        prvního zadání kódu z letáku.
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="reporting-parameters">
                        <div class="funnel-body">
                            <div>
                                <div>
                                    <h3>monitoring</h3>
                                </div>
                                <div>
                                    <h3>celkově</h3>
                                </div>
                            </div>
                            <div>
                                <div class="reporting-list">
                                    <div>
                                        <div>Hmotnost</div>
                                        <div
                                            v-bind:class="{
                                                'negative-number': isPositiveProgress(doctor.patient_values.weight),
                                                'positive-number':
                                                    isPositiveProgress(doctor.patient_values.weight) === false
                                            }"
                                            class="parameter-number"
                                        >
                                            <div
                                                class="status-arrow"
                                                v-if="
                                                    doctor.patient_values.weight !== 0 && doctor.patient_values.weight
                                                "
                                            >
                                                <img
                                                    v-if="isPositiveProgress(doctor.patient_values.weight)"
                                                    :src="arrows.down"
                                                />
                                                <img v-else :src="arrows.up" />
                                            </div>
                                            <div>{{ dotToComma(doctor.patient_values.weight) }} kg</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="reporting-list">
                                    <div>
                                        <div>Obvod pasu</div>
                                        <div
                                            v-bind:class="{
                                                'negative-number': isPositiveProgress(doctor.patient_values.waist),
                                                'positive-number':
                                                    isPositiveProgress(doctor.patient_values.waist) === false //because data can be null
                                            }"
                                            class="parameter-number"
                                        >
                                            <div
                                                class="status-arrow"
                                                v-if="doctor.patient_values.waist !== 0 && doctor.patient_values.waist"
                                            >
                                                <img
                                                    v-if="isPositiveProgress(doctor.patient_values.waist)"
                                                    :src="arrows.down"
                                                />
                                                <img v-else :src="arrows.up" />
                                            </div>
                                            <div>{{ dotToComma(doctor.patient_values.waist) }} cm</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data() {
            return {
                isSorted: true,
                isPositiveWeightProgress: true,
                isPositiveWaistProgress: true,
                regionsLocalStorageParsed: [],
                companiesLocalStorageParsed: [],
                dateFromLocalStorage: '',
                dateToLocalStorage: '',
                fetching: true,

                region: {
                    CZ: '/imgs/reporting/czech-flag.svg',
                    SK: '/imgs/reporting/slovakia-flag.svg',
                    DE: '/imgs/reporting/german-flag.svg'
                },
                arrows: {
                    up: '/imgs/reporting/arrow-up-red.svg',
                    down: '/imgs/reporting/arrow-down-green.svg'
                }
            }
        },

        computed: {
            ...mapGetters({
                allDoctors: 'reporting/allDoctors'
            }),
            doctors() {
                return this.allDoctors
            }
        },

        created() {
            this.initialData()

            if (!this.fetching) {
                this.apiDoctors({
                    countries: this.regionsLocalStorageParsed,
                    institutions: this.companiesLocalStorageParsed,
                    date_from: this.dateFromLocalStorage,
                    date_to: this.dateToLocalStorage
                }).then(() => {
                    this.sortingByDate('newest')
                })
            }
        },

        methods: {
            ...mapActions({
                apiDoctors: 'reporting/apiDoctors'
            }),

            sortingByDate(typeOfSorting) {
                const newest = 'newest'
                const oldest = 'oldest'

                if (typeOfSorting === newest) {
                    this.allDoctors.sort(function(a, b) {
                        return moment(b.registered_at) - moment(a.registered_at)
                    })

                    this.isSorted = true

                    return
                }

                if (typeOfSorting === oldest) {
                    this.allDoctors.sort(function(a, b) {
                        return moment(a.registered_at) - moment(b.registered_at)
                    })

                    this.isSorted = false

                    return
                }
            },

            //duplicate from Parameteres.vue
            dotToComma(arg) {
                if (arg !== null) {
                    //round number
                    arg = Math.round(arg * 10) / 10
                    if (arg > 0) {
                        arg = '+' + arg
                    }
                    //this.isPositiveProgress();
                    return arg.toString().replace('.', ',')
                }
                return 0
            },

            isPositiveProgress(progressStatus) {
                if (progressStatus > 0) {
                    return false
                }

                if (progressStatus < 0) {
                    return true
                }
            },

            allInactivated(inactivatedDoctors) {
                let result = 0
                if (inactivatedDoctors !== null) {
                    result =
                        inactivatedDoctors.inapp +
                        inactivatedDoctors.inactivated_patients_intensive_phase +
                        inactivatedDoctors.onboarding +
                        (inactivatedDoctors.connected - inactivatedDoctors.inactivated_patients_intensive_phase)
                }
                return result
            },

            dateFormater(date) {
                return moment(date).format('l')
            },

            buildAvatar(doctor) {
                const avatar = doctor.avatar
                const initials = doctor.name.substr(0, 1) + doctor.surname.substr(0, 1)

                if (avatar && avatar.endsWith('.jpg')) {
                    return `<img src="${avatar}" alt="Avatar" />`
                } else {
                    return initials
                }
            },

            initialData() {
                const regionsLocalStorage = window.localStorage.regions

                if (regionsLocalStorage) {
                    this.regionsLocalStorageParsed = JSON.parse(regionsLocalStorage)
                }

                const companiesLocalStorage = window.localStorage.companies

                if (companiesLocalStorage) {
                    this.companiesLocalStorageParsed = JSON.parse(companiesLocalStorage)
                }

                this.dateFromLocalStorage = window.localStorage.date_from
                this.dateToLocalStorage = window.localStorage.date_to

                if (!this.dateToLocalStorage && !this.dateFromLocalStorage) {
                    this.dateFromLocalStorage = moment()
                        .add(-7, 'days')
                        .format('YYYY-MM-DD')
                    this.dateToLocalStorage = moment().format('YYYY-MM-DD')
                }

                this.fetching = false

                return
            }
        }
    }
</script>
